import { render, staticRenderFns } from "./menerima.vue?vue&type=template&id=44211882&scoped=true&"
import script from "./menerima.vue?vue&type=script&lang=js&"
export * from "./menerima.vue?vue&type=script&lang=js&"
import style0 from "./menerima.vue?vue&type=style&index=0&id=44211882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44211882",
  null
  
)

export default component.exports